import { getIdentifier } from '~/mst/utils';
import { IDevicePofilesModel } from './model';
import { IDevicePofile } from '~/mst/models/device_profile';

export default (self: IDevicePofilesModel) => ({
  get cms2567Profiles() {
    return self.toArray.filter((profile) => getIdentifier(profile).startsWith('aecc'));
  },
  get cms2567ProfilesByGroup(): Record<string, IDevicePofile[]> {
    const grouped: Record<string, IDevicePofile[]> = {};
    for (const profile of self.toArray.filter((p) => getIdentifier(p).startsWith('aecc')) as IDevicePofile[]) {
      const group = profile.group;
      if (group) {
        if (!grouped[group]) grouped[group] = [];
        grouped[group].push(profile);
      }
    }
    return grouped;
  }
});
